(function (angular) {

  angular.module("alk.modal", []);

})(window.angular);

require("./alkModalService");



// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/alk-modal/module.js